import type { SerializedManufacturer } from '@enmon/commons/lib/tools';
import type { TableColumnsType } from 'antd';
import { EmptyCell } from 'components';
import { Link } from 'react-router-dom';
import type { Key, SortOrder } from 'antd/lib/table/interface';
import { ActionButton } from '../../../../../components/button/Action';

const WebsiteLink = ({ website }: { website: string }) => {
  const formattedWebsite =
    website.startsWith('http://') || website.startsWith('https://') ? website : `http://${website}`;
  return (
    <a href={formattedWebsite} rel="noopener noreferrer" target="_blank">
      {website}
    </a>
  );
};

export const getManufacturersColumnsConfig = ({
  loading,
  isMagicRole,
  onClick,
  onDelete,
  sortState,
}: {
  loading: boolean;
  isMagicRole: boolean;
  onClick: (manufacturerId: SerializedManufacturer['id']) => void;
  onDelete: (manufacturerId: SerializedManufacturer['id']) => void;
  sortState: { field: Key | null; order: SortOrder };
}): TableColumnsType<SerializedManufacturer> => [
  {
    key: 'name',
    title: 'Name',
    sorter: true,
    sortOrder: sortState.field === 'name' ? sortState.order : null,
    width: 400,
    render: (_, record) => <Link to={{ pathname: `manufacturer/${record.id}` }}>{record.name}</Link>,
  },
  {
    key: 'website',
    title: 'Website',
    width: 600,
    render: (_, record) => <>{record.website ? <WebsiteLink website={record.website} /> : <EmptyCell />}</>,
  },
  {
    key: 'modelsCount',
    title: 'Meter models count',
    sorter: true,
    sortOrder: sortState.field === 'modelsCount' ? sortState.order : null,
    width: 200,
    render: (_, record) => record.meter_models?.length ?? 0,
  },
  ...(isMagicRole
    ? ([
        {
          key: 'action',
          width: 150,
          title: 'Actions',
          fixed: 'right',
          render: (_, record) => (
            <ActionButton isLoading={loading} onClick={() => onClick(record.id)} onDelete={() => onDelete(record.id)} />
          ),
        },
      ] satisfies TableColumnsType<SerializedManufacturer>)
    : []),
];
